import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
// ========== HEADER CONTAINER ==========
export const HeaderContainer = styled.header `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 72px;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
  z-index: 1000;
  transition: all 0.3s ease;
`;
export const HeaderContent = styled.div `
  max-width: 1400px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 40px;
  position: relative;

  @media (max-width: 1024px) {
    padding: 0 20px;
  }
`;
export const HeaderLeft = styled.div `
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
`;
export const HeaderRight = styled.div `
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
`;
// ========== LOGO ==========
export const Logo = styled(Link) `
  font-family: 'Playfair Display', 'Adamina', serif;
  font-size: 24px;
  font-weight: 500;
  color: var(--text-primary);
  text-decoration: none;
  letter-spacing: 0.05em;
  transition: all 0.3s ease;

  &:hover {
    color: var(--accent-gold, #B8860B);
    letter-spacing: 0.07em;
  }

  span {
    color: var(--accent-gold, #B8860B);
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;
// ========== NAVIGATION ==========
export const Navigation = styled.nav `
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 1024px) {
    display: none;
  }
`;
export const LeftNav = styled(Navigation) ``;
export const RightNav = styled(Navigation) ``;
export const NavLink = styled(Link) `
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 6px;
  position: relative;
  transition: all 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 2px;
    background: var(--accent-gold, #B8860B);
    transition: width 0.2s ease;
  }

  &:hover {
    color: var(--text-primary);
    background: var(--accent-gold-bg, rgba(184, 134, 11, 0.08));
  }

  &:hover::after {
    width: calc(100% - 32px);
  }

  &.active {
    color: var(--accent-gold, #B8860B);
  }

  &.active::after {
    width: calc(100% - 32px);
  }
`;
// ========== HEADER ACTIONS ==========
export const HeaderActions = styled.div `
  display: flex;
  align-items: center;
  gap: 16px;
`;
// ========== THEME TOGGLE ==========
export const ThemeToggle = styled.button `
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--border-color);
  background: var(--bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--text-secondary);

  &:hover {
    background: var(--accent-gold-bg, rgba(184, 134, 11, 0.08));
    border-color: var(--accent-gold, #B8860B);
    color: var(--accent-gold, #B8860B);
    transform: rotate(15deg);
  }

  svg {
    width: 18px;
    height: 18px;
    transition: transform 0.3s ease;
  }
`;
// ========== LOGIN BUTTON ==========
export const LoginButton = styled.button `
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: white;
  background: var(--accent-gold, #B8860B);
  border: none;
  padding: 10px 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    background: var(--accent-gold-dark, #8B6914);
    transform: translateY(-2px);
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;
// ========== USER MENU ==========
export const UserMenuContainer = styled.div `
  position: relative;

  @media (max-width: 1024px) {
    display: none;
  }
`;
export const UserTrigger = styled.div `
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px 6px 6px;
  border-radius: 100px;
  border: 1px solid var(--border-color);
  background: var(--bg-tertiary);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--accent-gold, #B8860B);
  }
`;
export const UserAvatar = styled.div `
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--accent-gold, #B8860B);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 14px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const UserName = styled.span `
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
`;
export const UserChevron = styled.span `
  color: var(--text-tertiary);
  display: flex;
  align-items: center;

  svg {
    width: 14px;
    height: 14px;
    transition: transform 0.2s ease;
    transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'rotate(0)'};
  }
`;
export const UserDropdown = styled.div `
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 280px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-lg, 0 8px 24px rgba(0, 0, 0, 0.12));
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transform: ${props => props.$isOpen ? 'translateY(0) scale(1)' : 'translateY(-10px) scale(0.95)'};
  transition: all 0.25s ease;
  z-index: 100;
`;
export const DropdownHeader = styled.div `
  padding: 20px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-tertiary);
`;
export const DropdownUserInfo = styled.div `
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;
export const DropdownAvatar = styled.div `
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--accent-gold, #B8860B);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 18px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const DropdownUserDetails = styled.div `
  h4 {
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0 0 4px 0;
  }
`;
export const RoleBadge = styled.span `
  display: inline-block;
  font-family: 'DM Sans', sans-serif;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 3px 8px;
  background: var(--accent-gold-bg, rgba(184, 134, 11, 0.08));
  color: var(--accent-gold, #B8860B);
  border: 1px solid var(--accent-gold, #B8860B);

  ${props => props.$roleLevel && props.$roleLevel >= 90 && css `
    background: linear-gradient(135deg, var(--accent-gold, #B8860B), var(--accent-gold-dark, #8B6914));
    color: white;
    border: none;
  `}
`;
export const DropdownEmail = styled.div `
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  color: var(--text-tertiary);
  word-break: break-all;
`;
export const DropdownMenuItems = styled.div `
  padding: 8px;
`;
export const DropdownItem = styled.button `
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  color: ${props => props.$danger ? 'var(--error-color, #DC2626)' : 'var(--text-secondary)'};
  text-decoration: none;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.15s ease;
  cursor: pointer;
  border: none;
  background: none;
  width: 100%;
  text-align: left;

  &:hover {
    background: ${props => props.$danger ? 'rgba(220, 38, 38, 0.1)' : 'var(--accent-gold-bg, rgba(184, 134, 11, 0.08))'};
    color: ${props => props.$danger ? 'var(--error-color, #DC2626)' : 'var(--text-primary)'};
    transform: translateX(4px);
  }

  svg {
    width: 16px;
    height: 16px;
    color: ${props => props.$danger ? 'var(--error-color, #DC2626)' : 'var(--text-tertiary)'};
    flex-shrink: 0;
  }

  &:hover svg {
    color: ${props => props.$danger ? 'var(--error-color, #DC2626)' : 'var(--accent-gold, #B8860B)'};
  }
`;
export const DropdownLink = styled(Link) `
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  color: ${props => props.$danger ? 'var(--error-color, #DC2626)' : 'var(--text-secondary)'};
  text-decoration: none;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.15s ease;

  &:hover {
    background: ${props => props.$danger ? 'rgba(220, 38, 38, 0.1)' : 'var(--accent-gold-bg, rgba(184, 134, 11, 0.08))'};
    color: ${props => props.$danger ? 'var(--error-color, #DC2626)' : 'var(--text-primary)'};
    transform: translateX(4px);
  }

  svg {
    width: 16px;
    height: 16px;
    color: ${props => props.$danger ? 'var(--error-color, #DC2626)' : 'var(--text-tertiary)'};
    flex-shrink: 0;
  }

  &:hover svg {
    color: ${props => props.$danger ? 'var(--error-color, #DC2626)' : 'var(--accent-gold, #B8860B)'};
  }
`;
export const DropdownDivider = styled.div `
  height: 1px;
  background: var(--border-color);
  margin: 8px;
`;
// ========== ADMIN MEGA MENU ==========
export const AdminMenuContainer = styled.div `
  position: relative;

  @media (max-width: 1024px) {
    display: none;
  }
`;
export const AdminTrigger = styled.button `
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  background: var(--bg-tertiary);
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--accent-gold, #B8860B);
    color: var(--accent-gold, #B8860B);
    background: var(--accent-gold-bg, rgba(184, 134, 11, 0.08));
  }

  ${props => props.$isOpen && css `
    border-color: var(--accent-gold, #B8860B);
    color: var(--accent-gold, #B8860B);
    background: var(--accent-gold-bg, rgba(184, 134, 11, 0.08));
  `}

  svg {
    width: 14px;
    height: 14px;
  }

  .chevron {
    transition: transform 0.2s ease;
    transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'rotate(0)'};
  }
`;
export const MegaMenu = styled.div `
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 560px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-lg, 0 8px 24px rgba(0, 0, 0, 0.12));
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transform: ${props => props.$isOpen ? 'translateY(0)' : 'translateY(-20px)'};
  transition: all 0.3s ease;
  z-index: 100;
`;
export const MegaMenuGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;
export const MegaMenuSection = styled.div `
  padding: 20px;
  border-right: 1px solid var(--border-color);
  transition: background 0.2s ease;

  &:last-child {
    border-right: none;
  }

  &:hover {
    background: var(--bg-tertiary);
  }
`;
export const MegaSectionTitle = styled.div `
  font-family: 'DM Sans', sans-serif;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--accent-gold, #B8860B);
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--accent-gold, #B8860B);
`;
export const MegaMenuItem = styled(Link) `
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin: 0 -12px;
  color: var(--text-secondary);
  text-decoration: none;
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  border-left: 3px solid transparent;
  transition: all 0.15s ease;

  &:hover {
    background: var(--accent-gold-bg, rgba(184, 134, 11, 0.08));
    color: var(--text-primary);
    border-left-color: var(--accent-gold, #B8860B);
    transform: translateX(6px);
  }

  &.active {
    background: var(--accent-gold-bg, rgba(184, 134, 11, 0.08));
    color: var(--accent-gold, #B8860B);
    border-left-color: var(--accent-gold, #B8860B);
  }

  svg {
    width: 14px;
    height: 14px;
    color: var(--text-tertiary);
    flex-shrink: 0;
  }

  &:hover svg {
    color: var(--accent-gold, #B8860B);
  }
`;
// ========== HAMBURGER ==========
export const HamburgerButton = styled.button `
  display: none;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--bg-tertiary);
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px;

  span {
    display: block;
    width: 20px;
    height: 2px;
    background: var(--text-primary);
    transition: all 0.3s ease;
  }

  &.open span:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
  }

  &.open span:nth-child(2) {
    opacity: 0;
  }

  &.open span:nth-child(3) {
    transform: rotate(-45deg) translate(5px, -5px);
  }

  @media (max-width: 1024px) {
    display: flex;
  }
`;
// ========== MOBILE MENU ==========
export const MobileOverlay = styled.div `
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
`;
export const MobileDrawer = styled.div `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 320px;
  max-width: 85vw;
  background: var(--bg-secondary);
  z-index: 999;
  transform: ${props => props.$isOpen ? 'translateX(0)' : 'translateX(100%)'};
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  @media (max-width: 480px) {
    width: 100%;
    max-width: 100%;
  }
`;
export const MobileDrawerHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid var(--border-color);
`;
export const MobileCloseButton = styled.button `
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--border-color);
  background: var(--bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-secondary);
  transition: all 0.2s ease;

  &:hover {
    background: var(--error-color, #DC2626);
    border-color: var(--error-color, #DC2626);
    color: white;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;
export const MobileUserSection = styled.div `
  padding: 20px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-tertiary);
`;
export const MobileUserInfo = styled.div `
  display: flex;
  align-items: center;
  gap: 12px;
`;
export const MobileUserAvatar = styled.div `
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--accent-gold, #B8860B);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 18px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const MobileUserDetails = styled.div `
  h4 {
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0 0 4px 0;
  }
`;
export const MobileNav = styled.nav `
  padding: 12px;
  flex: 1;
`;
export const MobileNavItem = styled(Link) `
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  color: var(--text-secondary);
  text-decoration: none;
  font-family: 'DM Sans', sans-serif;
  font-size: 15px;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: var(--accent-gold-bg, rgba(184, 134, 11, 0.08));
    color: var(--text-primary);
    transform: translateX(8px);
  }

  &.active {
    background: var(--accent-gold-bg, rgba(184, 134, 11, 0.08));
    color: var(--accent-gold, #B8860B);
    border-left: 3px solid var(--accent-gold, #B8860B);
  }

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
`;
export const MobileDivider = styled.div `
  height: 1px;
  background: var(--border-color);
  margin: 8px 16px;
`;
export const MobileSectionHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  margin-top: 8px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: var(--bg-tertiary);
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 12px;
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
  }

  .header-left svg {
    width: 18px;
    height: 18px;
    color: var(--accent-gold, #B8860B);
  }

  .chevron {
    color: var(--text-tertiary);
    transition: transform 0.25s ease;
    transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'rotate(0)'};
    display: flex;
    align-items: center;
  }

  .chevron svg {
    width: 16px;
    height: 16px;
  }
`;
export const MobileSubmenu = styled.div `
  max-height: ${props => props.$isOpen ? '500px' : '0'};
  overflow: hidden;
  transition: max-height 0.25s ease;
`;
export const MobileSubmenuItem = styled(Link) `
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px 12px 48px;
  color: var(--text-secondary);
  text-decoration: none;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background: var(--accent-gold-bg, rgba(184, 134, 11, 0.08));
    color: var(--accent-gold, #B8860B);
  }

  &.active {
    color: var(--accent-gold, #B8860B);
  }

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;
export const MobileFooter = styled.div `
  padding: 16px;
  border-top: 1px solid var(--border-color);
  margin-top: auto;
`;
export const MobileFooterItem = styled.button `
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  color: ${props => props.$danger ? 'var(--error-color, #DC2626)' : 'var(--text-secondary)'};
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  transition: all 0.2s ease;

  &:hover {
    background: ${props => props.$danger ? 'rgba(220, 38, 38, 0.1)' : 'var(--accent-gold-bg, rgba(184, 134, 11, 0.08))'};
    color: ${props => props.$danger ? 'var(--error-color, #DC2626)' : 'var(--text-primary)'};
  }

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
`;
